export enum Entity {
  AlertLog = 'AlertLog',
  AlertSetup = 'AlertSetup',
  Asset = 'Asset',
  AssetByType = 'AssetByType',
  AssetDocument = 'AssetDocument',
  AssetField = 'AssetField',
  AssetFieldsValues = 'AssetFieldsValues',
  AssetLocation = 'AssetLocation',
  AssetLog = 'AssetLog',
  AssetType = 'AssetType',
  AssetUser = 'AssetUser',
  AvailableCardReaders = 'AvailableCardReaders',
  AvailableKeyfobs = 'AvailableKeyfobs',
  CardReader = 'CardReader',
  CardReaderLog = 'CardReaderLog',
  DamageReport = 'DamageReport',
  DamageReportDocument = 'DamageReportDocument',
  DataFilter = 'DataFilter',
  Department = 'Department',
  Emission = 'Emission',
  EmissionClass = 'EmissionClass',
  EmissionPrPurpose = 'EmissionPrPurpose',
  FinancingType = 'Enum_FinancingType',
  ExpenseSetup = 'ExpenseSetup',
  ExpenseSetupVehicle = 'ExpenseSetupVehicle',
  FerryDeal = 'FerryDeal',
  Find = 'Find',
  Fleet = 'Fleet',
  FleetFilter = 'FleetFilter',
  FleetLocation = 'FleetLocation',
  FuelType = 'FuelType',
  Keyfob = 'Keyfob',
  MileageAdjustment = 'MileageAdjustment',
  OnCall = 'OnCall',
  OnCallFilter = 'OnCallFilter',
  OnCallLog = 'OnCallLog',
  OnCallSetting = 'OnCallSetting',
  OnCallSite = 'OnCallSite',
  POI = 'POI',
  POIType = 'POIType',
  Permission = 'Permission',
  PermissionLog = 'PermissionLog',
  PayrollSettings = 'PayrollSettings',
  Preference = 'UserSetting',
  PredefinedGeofence = 'PredefinedGeofence',
  ReportSetting = 'ReportSetting',
  ReportType = 'ReportType',
  Role = 'Role',
  RolePermission = 'RolePermission',
  TagUser = 'TagUser',
  TagVehicle = 'TagVehicle',
  Tracker = 'Tracker',
  TrackerLog = 'TrackerLog',
  TrackerObject = 'TrackerObject',
  Trip = 'Trip',
  TripExpense = 'TripExpense',
  TripExpenseSetup = 'TripExpenseSetup',
  TripSetting = 'TripSetting',
  TripWithPoints = 'TripWithPoints',
  User = 'User',
  UserEventLog = 'UserEventLog',
  UserField = 'UserField',
  UserFieldsValues = 'UserFieldsValues',
  UserLocation = 'UserLocation',
  UserPermission = 'UserPermission',
  UserRole = 'UserRole',
  UserWithRole = 'UserWithRole',
  Vehicle = 'Vehicle',
  VehicleAssetLocation = 'VehicleAssetLocation',
  VehicleDocument = 'VehicleDocument',
  VehicleField = 'VehicleField',
  VehicleFieldsValues = 'VehicleFieldsValues',
  VehicleFilter = 'VehicleFilter',
  VehicleInMap = 'VehicleInMap',
  VehicleTripSetting = 'VehicleTripSetting',
  VehicleType = 'VehicleType',
  VippsMerchant = 'VippsMerchant',
  VippsPayment = 'VippsPayment',
  WarehouseTracker = 'WarehouseTracker',
  RouteNetworkMaintainerType = 'RouteNetworkMaintainerType',
  Device = 'Device',
  RouteNetwork = 'RouteNetwork',
  RouteNetworkWeb = 'RouteNetworkWeb',
  RouteSegment = 'RouteSegment',
  EnumWeatherCondition = 'EnumWeatherCondition',
  EnumIncidentType = 'EnumIncidentType',
  EnumDamageLocation = 'EnumDamageLocation',
  EnumDamageSeverity = 'EnumDamageSeverity',
  EnumVehicleIncidentAction = 'EnumVehicleIncidentAction',
  EnumDamageReportStatus = 'EnumDamageReportStatus',
  // not in db
  AssetDetail = 'AssetDetail',
  VehicleDetail = 'VehicleDetail',
}

export const NEW_ENTITY_ROUTE_PARAM = 'new';
